import { useTranslation } from '@thoughtspot/i18n';
import { Vertical } from '@thoughtspot/radiant-react/widgets/layout';
import { Modal, ModalSize } from '@thoughtspot/radiant-react/widgets/modal';
import { Typography } from '@thoughtspot/radiant-react/widgets/typography';
import React from 'react';
import { ModalActions, TranslationKeys, } from '../constants';
export const DisclaimerModal = ({ isModalOpen, setIsModalOpen, }) => {
    const { t } = useTranslation();
    const onModalClose = (action) => {
        setIsModalOpen(action);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Modal, { title: t(TranslationKeys.CONFIRMATION_MODAL_TITLE), isOpen: isModalOpen, dismissButton: {
                text: t(TranslationKeys.CANCEL_CTA),
            }, onDismiss: () => onModalClose(ModalActions.CANCEL), size: ModalSize.SMALL, confirmButton: {
                text: t(TranslationKeys.ENABLE_CTA),
                onConfirm: () => onModalClose(ModalActions.CONFIRM),
            } },
            React.createElement(Vertical, { "data-testid": "disclaimer-modal" },
                React.createElement(Typography, { preserveWhitespace: false, variant: "p" }, t(TranslationKeys.CSV_UPLOAD_DISCLAIMER))))));
};
//# sourceMappingURL=disclaimer-modal.js.map